<template>
  <div class="top_setting_btn" :style="topSettingStyle1">
    <!-- <div class="wrapper" v-show="showTopSetting && ids.swiperContent_id === swiperContent_id">
      <cx-tooltip content="克隆样式" class="set-groups">
        <span class="icon icon-portal-clone" @click.stop="toClonePattern"></span>
      </cx-tooltip>
    </div> -->
    <div @click="showSetting" v-show="showIcon" :style="topSettingStyle">
      <el-tooltip content="克隆样式" placement="top" >
        <span class="icon icon-portal-clone" @click.stop="toClonePattern"></span>
      </el-tooltip>
      <!-- <span class="icon arrow-icon icon-portal-arrows-up" v-else></span> -->
    </div>
  </div>
</template>

<script>
import store from "../../../store"
import { handleFindLayoutComponentOptionsCols } from "vue-awesome-swiper/dist/exporter.esm"
export default {
  props: {
    isActiveCol: {
      type: Boolean,
      required: true
    },
    ids: Object,
    myid: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    swiperContent_id: {
      type: Number,
      required: true
    },
    pageContent: {
      type: Object
    },
  },
  data() {
    return {
      isMounted: false,
      showTopSetting: false,
      isLast: false,
      isFirst: false,
      isTopCol: false,
      isOnlyCol: false,
      colPath: []
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    rectEl() {
      return document.getElementsByClassName(
        this.$event.getIdsByStrId({
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id
        })
      )[0]
    },
    showIcon() {
      if(!this.rectEl){
        return
      }
      if (this.isMounted === false || this.options.activeCol === ""){
        // 轮播在未被选中时需要恢复层级，解决在大屏后拖入的组件在轮播上面，切换轮播样式后后拖入的组件看不见的问题，
        this.rectEl.style.zIndex = this.options.hasOwnProperty("zIndex") ? this.options.zIndex : "auto"
        return false
      }
      const isShow = this.isActiveCol
      if (isShow) {
        this.rectEl.style.zIndex = 9999999
      } else if (this.ids.container_id !== this.myid.container_id || this.ids.rect_id !== this.myid.rect_id) {
        this.rectEl.style.zIndex = this.options.hasOwnProperty("zIndex") ? this.options.zIndex : "auto"
      }
      return isShow
    },
    topSettingStyle() {
      return {
        "--toolTopBackgroundColor": this.request_prefix.includes("bigScreen") ? "white" : "black",
        "--toolTopFontColor": this.request_prefix.includes("bigScreen") ? "black" : "white",
        "--settingShow": this.showTopSetting ? "scale(1.3)" : "scale(1)"
      }
    },
    topSettingStyle1(){
      let btnLeftStr = {
        "--settingBtnRight": "8px",
        "--settingBtnLeft": "auto"
      }
      let btnTopStr = {
        "--settingBtnTop": "8px",
        "--settingBtnBottom": "auto"
      }
      if(this.showIcon && this.options.curve){ //是弧形轮播且值大于0
        if(this.options.direction === "vertical" && this.options.swiperRadian > 0){
          btnLeftStr = {
            "--settingBtnRight": "auto",
            "--settingBtnLeft": "8px",
          }
        }else if(this.options.direction === "horizontal" && this.options.swiperRadian < 0){
          btnTopStr = {
            "--settingBtnTop": "auto",
            "--settingBtnBottom": "8px",
          }
        }
      }
      return {...btnLeftStr, ...btnTopStr}
    }
  },
  methods: {
    getColPath() {
      this.colPath = this.pageContent || []
    },
    //进入克隆模式
    toClonePattern() {
      this.showTopSetting = false
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const pOptions = rectAttr.options.content[this.options.activeCol]
      let allSlide = rectAttr.options.content
      const detailsPageTarget = rectAttr.options.content[this.options.activeCol]?.options?.detailsPageTarget
      let syncFlag = false
      for (let i = 0; i < allSlide.length; i++) {
        const result = {
            content: JSON.parse(JSON.stringify(pOptions)),
            container_id: this.ids.container_id,
            rect_id: this.ids.rect_id,
            swiperContent_id: allSlide[i].swiperContent_id,
            baseSwiperContent_id: this.swiperContent_id
        }
        this.$store.dispatch(this.request_prefix + "/swiperContentUpdate", result)
        // 同步链接跳转选中项
        const result1 = {
          content: detailsPageTarget,
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          swiperContent_id: allSlide[i].swiperContent_id
        }
        this.$store.dispatch(this.request_prefix + "/swiperContentOptionsUpdate", result1)
        syncFlag = true
      }
      if (syncFlag) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "克隆成功",
          type: "success"
        })
      }
      // 同步后直接渲染数据 模拟点击
      let getDataBtn = document.getElementsByClassName("toolbar")[0].getElementsByClassName("getDataBtn")
      if (getDataBtn.length > 0) {
        getDataBtn[0].click()
      }
      // 刷新轮播图 解决复制的轮播页样式没有同步成功
      this.$emit("reSetComponent")
    },
    calcIsLast(deep = 0) {
      if (this.isMounted === false) {
        this.isLast = false
        this.isFirst = false
      }
      const currCol = this.$el?.parentNode
      const corrCols = currCol?.parentNode.childNodes
      if (!corrCols && deep < 10) requestAnimationFrame(() => this.calcIsLast(deep + 1))
      else {
        const index = Array.prototype.findIndex.call(corrCols, item => item === currCol)
        this.isLast = index === corrCols.length - 1
        this.isFirst = index === 0
      }
    },
    calcIsOnlyCol() {
      if (this.isMounted === false) this.isOnlyCol = false
      this.isOnlyCol = this.$el.parentNode.parentNode.childNodes.length === 1
    },
    hiddenSetting() {
      this.showTopSetting = false
    },
    showSetting() {
      this.showTopSetting = !this.showTopSetting
      if (this.showTopSetting) {
        this.$emit("activeCol")
        this.calcDeps()
      } else {
        this.setPageLayoutWrapZindex(false)
      }
    },
    calcDeps() {
      this.calcIsLast()
      this.getColPath()
      this.calcIsOnlyCol()
      this.setPageLayoutWrapZindex(true)
    },
    // 设置外层页面布局的层级 当前的为最高
    setPageLayoutWrapZindex(show) {
      let parentNode = this.getParentNode(this.$el)
      if (parentNode.length === 0) {
        return
      }
      if (show) {
        parentNode[0].setAttribute("data-level", "top-level")
      } else {
        parentNode[0].removeAttribute("data-level")
      }
    },
    getParentNode(e, res = []) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        // if(elClasslist.length === 0){
        //   return res
        // }
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === "page-layout-wrapper")) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNode(parentNode, res)
        }
      } else {
        return res
      }
    },
  }
}
</script>

<style scoped>
.top_setting_btn {
  z-index: 9999999;
  position: absolute;
  top: var(--settingBtnTop);
  bottom: var(--settingBtnBottom);
  right: var(--settingBtnRight);
  left: var(--settingBtnLeft);
}
.wrapper {
  color: var(--toolTopFontColor);
  background-color: #283959;
  white-space: nowrap;
  margin-bottom: 10px;
  position: absolute;
  left: -28px;
  transform: translateX(-50%);
  border-radius: 999px;
  padding: 0 8px;
  transition: top 0.4s;
  height: 34px;
  top: -2px;
  transition: 0.4s;
}
.wrapper::after {
  /* display: block; */
  position: absolute;
  content: "";
  width: 100%;
  height: 20px;
  bottom: -20px;
  left: 0px;
}
.content span {
  padding: 1px;
  border-radius: 2px;
  line-height: 17px;
}
.set-groups:not(:last-child) {
  display: inline-block;
  vertical-align: middle;
  border-right: 1px solid #42516d;
}
.icon {
  font-size: 18px;
  text-align: center;
  line-height: 34px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
}
.set-groups {
  display: inline-block;
  vertical-align: middle;
  width: 34px;
  height: 34px;
}
.set-groups .icon:hover {
  color: rgba(255, 255, 255, 1);
}
.arrow-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  padding-right: 1px;
  text-align: center;
  background-color: var(--themeColor);
  color: #fff;
  border-radius: 50%;
  transition: all 0.1s;
  cursor: pointer;
  transform: var(--settingShow);
}
.icon-portal-move {
  padding-right: 0px;
}
.arrow-icon:hover {
  cursor: pointer;
}
::v-deep .content {
  line-height: 38px;
}
.arrow-icon.icon-portal-clone {
  font-size: 14px;
}
.top_setting_btn .el-tooltip {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  text-align: center;
  background-color: var(--themeColorHover);
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
}
.top_setting_btn .el-tooltip:hover {
  background-color: var(--themeColor);
}
</style>
